import { Locale } from '@cars4ever/public-ui';

export interface IZipCodesLookupConfig {
  country: string;
}

const zipCodesLookupConfig: Record<Locale, IZipCodesLookupConfig> = {
  [Locale.DK]: {
    country: 'DK',
  },
  [Locale.SE]: {
    country: 'SE',
  },
};
export default zipCodesLookupConfig;
